import { render, staticRenderFns } from "./embedded_index.vue?vue&type=template&id=0e28a35a&scoped=true&"
import script from "./embedded_index.vue?vue&type=script&lang=js&"
export * from "./embedded_index.vue?vue&type=script&lang=js&"
import style0 from "./embedded_index.vue?vue&type=style&index=0&id=0e28a35a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28a35a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fembedded%2Fembedded_index.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./embedded_index.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports